// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
aws_app_analytics : 'enable',
aws_cognito_identity_pool_id : 'us-east-1:63e5cc82-ff33-43da-a64c-54d8d6959291',
aws_cognito_region : 'us-east-1',
aws_content_delivery : 'enable',
aws_content_delivery_bucket : 'blogmanagement-hosting-mobilehub-1183121982',
aws_content_delivery_bucket_region : 'us-east-1',
aws_content_delivery_cloudfront : 'enable',
aws_content_delivery_cloudfront_domain : 'd3hhhs9r4cmhfz.cloudfront.net',
aws_mobile_analytics_app_id : 'c7f98a8c6871485983bc01ac76d88354',
aws_project_id : 'e9858f73-49bf-4a23-8c49-988e3d57f038',
aws_project_name : 'blog-management',
aws_project_region : 'us-east-1',
aws_resource_name_prefix : 'blogmanagement-mobilehub-1183121982',
}

export default awsmobile;
var AWS = require('aws-sdk');
AWS.config.region = awsmobile.aws_project_region;
AWS.config.update({customUserAgent: 'MobileHub v0.1'});


// WEBPACK FOOTER //
// ./src/configuration/aws-exports.js